module.exports = __webpack_public_path__ + "bf103a88b827dc8072888b99d3f6fa60.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/facebook-plus-socialnative.svg
// module id = 3336
// module chunks = 69